// extracted by css-extract-rspack-plugin
var _1 = "mKu9B";
export { _1 as "mecontrolPlaceHolderStyle" }
